import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HospitalService } from '../../_service/hospital.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TpaService } from 'src/app/_service/tpa.service';

@Component({
  selector: 'app-tpa-details',
  templateUrl: './tpa-details.component.html',
  styleUrls: ['./tpa-details.component.css']
})
export class TpaDetailsComponent implements OnInit {
  tpaCostForm: FormGroup; treatments=[];treatments_copy=[];TpaCostList=[];activeTab='0';tpaCost:boolean=false;tpaCostId:any;HospitalId:any;loading:boolean=false;submitted = false;tpaList=[];tpaList_copy=[];myrole:string;
  @Input() hospitalName = '';
  @ViewChild('tpaSearch') tpaSearchElement: ElementRef;
  @ViewChild('treatmentSearch') treatmentSearchElement: ElementRef;
  constructor(private hospitalapi:HospitalService,private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,public leadapi:LeadsService,private activatedRoute: ActivatedRoute, private tpaService: TpaService) {
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.getTreatment();
    this.getTpa();
    this.tpaCostForm = this.formBuilder.group({
      'treatment_id' : [null, Validators.required],
      'price' : [null, Validators.required],
      'max_price' : [null, Validators.required],
      'hospital_id': [null],
      'tpa_ins_id': [null, Validators.required],
      'ins_comp_id':[null, Validators.required]
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['hospital_id']) {
          this.HospitalId = params['hospital_id'];
          this.getHospitalTpaCostList();
      }

  });

  }

  ngOnInit(): void {
  }

  get t() { return this.tpaCostForm.controls; }

  async getTreatment()
  {
      await this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.treatments = data.data;
              this.treatments_copy= this.treatments;
          }else{
              this.treatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async createHospitalTpacost(){
    console.log(this.tpaCostForm);
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.tpaCostForm.invalid) {
        this.loading = false;
        return;
    }
    this.tpaCostForm.value.hospital_id= parseInt(this.HospitalId);

    console.log(this.tpaCostForm);
    //return false;
    if(this.tpaCost){
        this.tpaCostForm.value.id= parseInt(this.tpaCostId);
            this.hospitalapi.updateTpaCost(this.tpaCostForm.value)
            .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('Treatment Cost Updated Successfully');
                    this.getHospitalTpaCostList();
                    this.activeTab='2';
                    this.resetForm();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
            }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }else{
            this.hospitalapi.addTpaCost(this.tpaCostForm.value).subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Tpa Cost Added Successfully');
                this.getHospitalTpaCostList();
                this.activeTab='2';
                this.tpaCostForm.reset();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
            }, error =>
            {
                this.sharedapi.checkError(error);
            });
        }
  }

  async getHospitalTpaCostList(){
    await this.hospitalapi.getTpaCostList(this.HospitalId).subscribe((data:any) => {
        if(data.status)
        {
            this.TpaCostList = data.data;
        }else{
            this.TpaCostList = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  searchOnSelect(searchtText: string, type){
    if(type == 'treatment'){
        this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    } else if(type == 'tpa'){
      this.tpaList = this.sharedapi.searchData(searchtText, this.tpaList_copy, "tpaName");
    } else if(type == 'ins_comp'){
      this.tpaList = this.sharedapi.searchData(searchtText, this.tpaList_copy, "insuranceCompanyName");
    }
  }

  setSearchValue(type){
    if(type=='treatment'){
      this.treatments= this.treatments_copy;
      this.treatmentSearchElement.nativeElement.focus();
      this.treatmentSearchElement.nativeElement.value = '';
    } else if(type=='tpa'){
      this.tpaList = this.tpaList_copy;
      this.tpaSearchElement.nativeElement.focus();
      this.tpaSearchElement.nativeElement.value = '';
    }  else if(type=='ins_comp'){
      this.tpaList = this.tpaList_copy;
      this.tpaSearchElement.nativeElement.focus();
      this.tpaSearchElement.nativeElement.value = '';
    }
  }

  async getTpa()
  {
    await this.tpaService.getTpaInsuranceList().subscribe((data: any)=> {
      if(data.status) {
        this.tpaList = data.data;
        this.tpaList_copy = this.tpaList;
      } else {
        this.tpaList = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  fetchTpaCostData(id){
    this.tpaCostId=id;
    this.hospitalapi.getTpaCostData(id).subscribe((response:any) => {
        if(response.status){
            this.tpaCost=true;
            this.tpaCostForm.patchValue({
                'treatment_id':response.data.treatment_id,
                'tpa_ins_id':response.data.tpa_ins_id,
                'ins_comp_id':response.data.tpa_ins_id,
                'price':response.data.cost,
                'max_price':response.data.max_cost
            })
        }

    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  resetForm(){
    this.tpaCost=false;
    this.submitted=false;
    this.tpaCostForm.reset();
  }

  setFormValue(event, control)
  {
    // console.log(event.value);
    if(control == 'tpa_id'){
      this.tpaCostForm.patchValue({
        'ins_comp_id': event.value
      });
    } else if(control == 'ins_comp_id'){
      this.tpaCostForm.patchValue({
        'tpa_ins_id': event.value
      });
    }
  }

}
